import { getAppIcon } from "./AppIcon";
import { getUserIcon } from "./UserIcon";
import { getOwnerIcon } from "./OwnerIcon";

import AdminIcon from "./AdminIcon";
import AnalyticsIcon from "./AnalyticsIcon";
import DashboardIcon from "./DashboardIcon";
import InboxIcon from "./InboxIcon";
import CalendarIcon, { getCalendarIcon } from "./CalendarIcon";

import ForumIcon from "./ForumIcon";
import SupportIcon from "./SupportIcon";

import ProfileIcon, { getProfileIcon } from "./ProfileIcon";
import SettingsIcon from "./SettingsIcon";

import Museum24Icon from "./M24Icon";
import DigitaltMuseumIcon from "./DmIcon";
import KulturPunktIcon from "./KpIcon";

import KompassIcon from "./KompassIcon";
import PrimusIcon from "./PrimusIcon";
import KulturNavIcon from "./KulturnavIcon";
import MinneIcon from "./MinnerIcon";
import MinnerIcon from "./MinnerIcon";

import OwnerIcon from "./OwnerIcon";

export { DashboardIcon, InboxIcon, CalendarIcon, ForumIcon, SupportIcon, ProfileIcon, AdminIcon, SettingsIcon, AnalyticsIcon, Museum24Icon, DigitaltMuseumIcon, KulturPunktIcon, PrimusIcon, KulturNavIcon, MinneIcon, MinnerIcon, OwnerIcon, getAppIcon, getUserIcon, getProfileIcon, getCalendarIcon, getOwnerIcon };

export default {
    "dashboard": DashboardIcon,
    "inbox": InboxIcon,
    "calendar": CalendarIcon,

    "forum": ForumIcon,
    "support": SupportIcon,

    "analytics": AnalyticsIcon,

    "admin": AdminIcon,
    "profile": ProfileIcon,
    "settings": SettingsIcon,

    "m24": Museum24Icon,
    "museum24": Museum24Icon,

    "dm": DigitaltMuseumIcon,
    "digitaltmuseum": DigitaltMuseumIcon,

    "ko": KompassIcon,
    "kompass": KompassIcon,

    "kp": KulturPunktIcon,
    "kulturpunkt": KulturPunktIcon,

    "pr": PrimusIcon,
    "primus": PrimusIcon,

    "kn": KulturNavIcon,
    "kulturnav": KulturNavIcon,

    "mi": MinneIcon,
    "minne": MinneIcon,
    "minner": MinneIcon
};